window.addEventListener("load", function () {
  /* BOX RECEITAS */
  const slider = document.querySelector(".list-recipes");
  const btnLeft = document.querySelector(".scroll-left");
  const btnRight = document.querySelector(".scroll-right");
  const scrollAmount = 300; // Distância para cada clique

  // Variáveis de controle para arrastar
  let isDown = false;
  let startX;
  let scrollLeft;

  // Eventos de scroll para os botões
  btnLeft.addEventListener("click", () => {
    slider.scrollLeft -= scrollAmount;
  });

  btnRight.addEventListener("click", () => {
    slider.scrollLeft += scrollAmount;
  });

  // Eventos de arrastar com o mouse
  slider.addEventListener("mousedown", (e) => {
    isDown = true;
    slider.classList.add("active");
    startX = e.pageX - slider.offsetLeft;
    scrollLeft = slider.scrollLeft;
  });

  slider.addEventListener("mouseleave", () => {
    isDown = false;
    slider.classList.remove("active");
  });

  slider.addEventListener("mouseup", () => {
    isDown = false;
    slider.classList.remove("active");
  });

  slider.addEventListener("mousemove", (e) => {
    if (!isDown) return;
    e.preventDefault();
    const x = e.pageX - slider.offsetLeft;
    const walk = (x - startX) * 2; // Velocidade de arrasto
    slider.scrollLeft = scrollLeft - walk;
  });

  // Para dispositivos móveis
  slider.addEventListener("touchstart", (e) => {
    isDown = true;
    startX = e.touches[0].pageX - slider.offsetLeft;
    scrollLeft = slider.scrollLeft;
  });

  slider.addEventListener("touchmove", (e) => {
    if (!isDown) return;
    const x = e.touches[0].pageX - slider.offsetLeft;
    const walk = (x - startX) * 2;
    slider.scrollLeft = scrollLeft - walk;
  });

  slider.addEventListener("touchend", () => {
    isDown = false;
    slider.classList.remove("active");
  });

  slider.addEventListener("touchcancel", () => {
    isDown = false;
    slider.classList.remove("active");
  });
});
/* END BOX RECEITAS */
